// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from '@leagueplatform/genesis-core';

export const healthCoTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#FFFFFFFF',
        secondary: '#F6F6F6FF',
        tertiary: '#F2F9FDFF',
      },
      card: {
        primary: '#F6F6F6FF',
        secondary: '#FFFFFFFF',
        disabled: '#E4E4E4FF',
      },
      screenHeader: { background: '#F2F9FDFF' },
      skeleton: {
        shimmer: {
          background: '#E4E4E4FF',
          overlay:
            'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
        },
      },
    },
    onSurface: {
      text: {
        primary: '#333333FF',
        subdued: '#646464FF',
        reversed: '#FFFFFFFF',
        critical: '#C63A39FF',
        success: '#507C03FF',
        warning: '#C94F08FF',
      },
      border: { subdued: '#D4D4D4FF', default: '#C2C2C2FF', card: '#EFEFEFFF' },
      icon: { primary: '#004E70FF' },
    },
    interactive: {
      action: {
        primary: '#007CB2FF',
        hovered: '#00638FFF',
        pressed: '#004E70FF',
        subdued: '#646464FF',
        disabled: '#E4E4E4FF',
      },
      icon: { default: '#FFFFFFFF', disabled: '#9A9A9AFF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E4E4E4FF',
        hovered: '#E4E4E4FF',
        pressed: '#E4E4E4FF',
      },
      border: {
        default: '#9A9A9AFF',
        hovered: '#646464FF',
        disabled: '#E4E4E4FF',
        critical: { default: '#C63A39FF' },
      },
      focus: { inner: '#015E60FF', outer: '#015E60FF' },
    },
    critical: {
      background: { subdued: '#FFE5E5FF', secondary: '#FFFFFFFF' },
      border: { default: '#C63A39FF' },
      icon: '#C63A39FF',
    },
    warning: {
      background: { subdued: '#FAE8D6FF', secondary: '#FFFFFFFF' },
      border: { default: '#E8A800FF' },
      icon: '#C79102FF',
    },
    success: {
      background: { subdued: '#E3F7F0FF', secondary: '#FFFFFFFF' },
      border: { default: '#008A09FF' },
      icon: '#008A09FF',
    },
    highlight: {
      background: { subdued: '#EDF8FFFF', secondary: '#FFFFFFFF' },
      border: { default: '#0093D4FF' },
      icon: '#0093D4FF',
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#004E70FF',
          dark: '#00638FFF',
          default: '#007CB2FF',
          bright: '#0093D4FF',
          brightest: '#CBE9F6FF',
          pastel: '#F2F9FDFF',
        },
        secondary: {
          darkest: '#0B6D6FFF',
          dark: '#18999AFF',
          default: '#1DB7B9FF',
          bright: '#A5E2E3FF',
          brightest: '#ECF9F9FF',
          pastel: '#FBFFFFFF',
        },
        tertiary: {
          darkest: '#CC9300FF',
          dark: '#E8A800FF',
          default: '#EDB933FF',
          bright: '#F6DC99FF',
          brightest: '#FAEECCFF',
          pastel: '#FDF7E8FF',
        },
      },
    },
    primary: {
      background: {
        default: '#78D4D5FF',
        hovered: '#1DB7B9FF',
        pressed: '#178788FF',
        critical: {
          default: '#C63A39FF',
          hovered: '#AD3130FF',
          pressed: '#922928FF',
        },
      },
      text: { default: '#004E70FF', critical: { default: '#FFFFFFFF' } },
    },
    secondary: {
      background: {
        default: '#FFFFFFFF',
        hovered: '#F2F9FDFF',
        pressed: '#0093D4FF',
      },
      text: { default: '#004E70FF', hovered: '#004E70FF' },
      border: { default: '#004E70FF' },
    },
    tertiary: {
      background: {
        default: '#FFFFFF00',
        hovered: '#ECF9F9FF',
        pressed: '#A5E2E3FF',
      },
      text: { default: '#0C8487FF', hovered: '#0C8487FF' },
      border: { default: '#0C8487FF' },
    },
    input: {
      border: {
        success: '#008A09FF',
        warning: '#C94F08FF',
        default: '#9A9A9AFF',
        hovered: '#646464FF',
        disabled: '#E4E4E4FF',
        critical: '#C63A39FF',
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E4E4E4FF',
        hovered: '#E4E4E4FF',
        pressed: '#E4E4E4FF',
      },
    },
    dataViz: {
      interface: { track: { border: '#99BBCFFF', background: '#F5F5F5FF' } },
      singleColor: { brand: '#007CB2FF', neutral: '#99BBCFFF' },
      status: {
        critical: '#C63A39FF',
        warning: '#E8A800FF',
        success: '#507C03FF',
      },
      categorical: {
        one: '#1DB7B9FF',
        two: '#E8A800FF',
        three: '#0093D4FF',
        four: '#99BBCFFF',
        five: '#18999AFF',
        six: '#007CB2FF',
      },
    },
  },
  shadows: {
    card: { x: 0, y: 4, blur: 8, spread: 0, color: '#E4E4E4CC' },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: '#0000001A' },
  },
  typography: {
    headingOne: {
      fontFamily: 'Literata',
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingTwo: {
      fontFamily: 'Literata',
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingThree: {
      fontFamily: 'Literata',
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    headingFour: {
      fontFamily: 'Literata',
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleOne: {
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    subtitleTwo: {
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOne: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyOneSecondary: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwo: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    bodyTwoSecondary: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonOne: {
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    buttonTwo: {
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    label: {
      fontFamily: 'Lato',
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none',
    },
    caption: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
    tab: {
      fontFamily: 'Lato',
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none',
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 0,
    large: 0,
    extraLarge: 0,
    huge: 0,
    circle: 9999,
    pill: 9999,
    button: 0,
    inputField: 0,
    card: 0,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: { headings: 'Literata', body: 'Lato' },
  transitions: { defaultTime: '200ms' },
};
